<template>
	<svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M29.3327 16.0001C29.3327 8.66675 23.3327 2.66675 15.9993 2.66675C8.66602 2.66675 2.66602 8.66675 2.66602 16.0001C2.66602 23.3334 8.66602 29.3334 15.9993 29.3334C23.3327 29.3334 29.3327 23.3334 29.3327 16.0001Z"
			:stroke="color_prop" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M12.2266 19.7735L19.7732 12.2268" :stroke="color_prop" stroke-width="1.5" stroke-linecap="round"
			stroke-linejoin="round" />
		<path d="M19.7732 19.7735L12.2266 12.2268" :stroke="color_prop" stroke-width="1.5" stroke-linecap="round"
			stroke-linejoin="round" />
	</svg>
</template>

<script>
import { extractValueAndUnit } from '@/utils/iconUtils'

export default {

	name: 'IconButtonClose',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem', // px|em|rem|%
		},

		height_prop: {
			type: String,
			default: '1rem', // px|em|rem|%
		},

		color_prop: {
			type: String,
			default: '',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	}
}
</script>

<style lang="css" scoped></style>